import { render, staticRenderFns } from "./w-logo.global.vue?vue&type=template&id=b6517b34&"
import script from "./w-logo.global.vue?vue&type=script&lang=js&"
export * from "./w-logo.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports